import { render, staticRenderFns } from "./comment-section.vue?vue&type=template&id=473b22ab&"
import script from "./comment-section.vue?vue&type=script&lang=js&"
export * from "./comment-section.vue?vue&type=script&lang=js&"
import style0 from "./comment-section.vue?vue&type=style&index=0&id=473b22ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports